import styled from 'styled-components'
import { useCertificate } from 'querys/certificates'
import { Typography } from 'common/typography'

const CertificateDescriptionStyled = styled.div`
  h1 {
    margin-block-end: 8px;
  }
`

function Certificate() {
  const { data: { course: { title }, user: { first_name, full_name } } } = useCertificate()

  return (
    <CertificateDescriptionStyled>
      <Typography small="headline6" large="headline4" as="h1">
        Certificado de
        {' '}
        {first_name}
      </Typography>
      <Typography>
        Este es el resultado del trabajo duro y dedicación que
        {' '}
        <b>{full_name}</b>
        {' '}
        puso al completar el curso de
        {' '}
        <b>{title}</b>
        {'.'}
        <br />
      </Typography>
    </CertificateDescriptionStyled>
  )
}

export default Certificate
